module.exports = __webpack_public_path__ + "img/recharge.93e0794c.png";